import { Box, Text } from '@frontend/legacy-components';

type ViewerButtonTooltipProps = {
  firstLine: string;
  secondLine: string;
};

/**
 * ViewerButtonTooltip formats two lines of text, for use in a Tooltip
 * The first line is shown in bold.
 */
const ViewerButtonTooltip = ({
  firstLine,
  secondLine,
}: ViewerButtonTooltipProps) => (
  <Box alignItems="center" display="flex" flexDirection="column">
    <Text fontWeight="bold" textColor="feature.onInteraction">
      {firstLine}
    </Text>
    <Text
      fontWeight="medium"
      textAlign="center"
      textColor="feature.onInteraction"
    >
      {secondLine}
    </Text>
  </Box>
);

export default ViewerButtonTooltip;
